










 

 










const node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ToggleTeamDrawerMutation_teamMember",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "TeamMember",
      "kind": "LinkedField",
      "name": "teamMember",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "openDrawer",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ToggleTeamDrawerSuccess",
  "abstractKey": null
};

(node ).hash = "9d5fe83524101820b3aceeccf59a0dac";

export default node;
